// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"497":"17d1a324","709":"6087d398"}[chunkId] + ".chunk.css";
};